import { render, staticRenderFns } from "./ComunicationList.vue?vue&type=template&id=1046e290&scoped=true"
import script from "./ComunicationList.vue?vue&type=script&lang=js"
export * from "./ComunicationList.vue?vue&type=script&lang=js"
import style0 from "./ComunicationList.vue?vue&type=style&index=0&id=1046e290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1046e290",
  null
  
)

export default component.exports